// Coach routes — served from the site root, like the other root-served pages.
// The coach shell — the parent route every in-app surface will live under. `/dashboard` is the
// name it was born with and still answers to: pages/unified/dashboard.vue redirects here with the
// query string untouched.
export const COACH_ROUTE_INDEX = '/coach';
// The coach's ambient surfaces: child routes of the shell, so opening one is a navigation the
// student can link to, reload and walk back out of, and none of them unmounts the shell (which
// starts a coach session every time it mounts). The URL noun is the student's word for the
// surface, which is not always the activity's: badges live in what the code calls the wallet.
export const COACH_ROUTE_ACCOUNT = `${COACH_ROUTE_INDEX}/account`;
export const COACH_ROUTE_BADGES = `${COACH_ROUTE_INDEX}/badges`;
// The entity surfaces, mirroring the public paths a signed-out student would be sent to. A single
// entity is a segment (`/coach/jobs/software-developers`), a set of them is the same page listed
// (`/coach/jobs?ids=…`), and a piece of content nests under the collection it belongs to.
export const COACH_ROUTE_JOBS = `${COACH_ROUTE_INDEX}/jobs`;
export const COACH_ROUTE_INSTITUTIONS = `${COACH_ROUTE_INDEX}/institutions`;
// The student's shortlisted jobs ("My pathways"), each with the routes into it; one job's routes
// compared side by side live under a segment (`/coach/saved-pathways/<occupationId>`). The URL
// noun is the student's word; the code and the coach's navigation vocabulary keep saying
// job-candidates, and `/coach/job-candidates{,/*}` redirects here for the links already out there.
export const COACH_ROUTE_JOB_CANDIDATES = `${COACH_ROUTE_INDEX}/saved-pathways`;
export const COACH_ROUTE_LEARN = `${COACH_ROUTE_INDEX}/learn`;
// What the student's school has set them. Its own surface rather than a shelf in the library: the
// library launches content, and a lesson is work that has to be opened as a coach session.
export const COACH_ROUTE_LESSONS = `${COACH_ROUTE_INDEX}/lessons`;
export const COACH_ROUTE_PORTFOLIO = `${COACH_ROUTE_INDEX}/portfolio`;
export const COACH_ROUTE_PROFILE = `${COACH_ROUTE_INDEX}/profile`;
export const COACH_ROUTE_REWARDS = `${COACH_ROUTE_INDEX}/rewards`;
export const COACH_ROUTE_SAVED = `${COACH_ROUTE_INDEX}/saved`;
